import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const ui = {
  es: {
    projects: 'Proyectos', portfolio: 'Portafolio', services: 'Servicios', members: 'Miembros', contact: 'Contacto',
    studio: 'Estudio indie de videojuegos basado en Argentina', explore: 'Explorar nuestros juegos', contactUs: 'Contactanos',
    teamTitle: 'Conoce al equipo', teamIntro: 'Un grupo chico, multidisciplinario y metido en cada parte del proceso.', viewCv: 'Ver CV',
    backTeam: 'Volver al equipo', downloadCv: 'Descargar CV', about: 'Sobre mí', skills: 'Habilidades', software: 'Software', languages: 'Idiomas',
    certifications: 'Certificaciones', experience: 'Experiencia', education: 'Educación', courses: 'Cursos', featuredProjects: 'Proyectos destacados',
    leadership: 'Liderazgo y experiencia adicional', notFound: 'CV no encontrado', back: 'Volver', language: 'Idioma'
  },
  en: {
    projects: 'Projects', portfolio: 'Portfolio', services: 'Services', members: 'Team', contact: 'Contact',
    studio: 'Indie game studio based in Argentina', explore: 'Explore our games', contactUs: 'Contact us',
    teamTitle: 'Meet the team', teamIntro: 'A small, multidisciplinary team involved in every part of the process.', viewCv: 'View résumé',
    backTeam: 'Back to the team', downloadCv: 'Download résumé', about: 'About me', skills: 'Skills', software: 'Software', languages: 'Languages',
    certifications: 'Certifications', experience: 'Experience', education: 'Education', courses: 'Courses', featuredProjects: 'Featured projects',
    leadership: 'Leadership and additional experience', notFound: 'Résumé not found', back: 'Back', language: 'Language'
  }
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => localStorage.getItem('nuclear-language') || (navigator.language?.startsWith('es') ? 'es' : 'en'));
  useEffect(() => {
    localStorage.setItem('nuclear-language', language);
    document.documentElement.lang = language;
  }, [language]);
  const value = useMemo(() => ({ language, setLanguage, t: (key) => ui[language][key] || key }), [language]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => useContext(LanguageContext);
